module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/jcb-c439a8c57cab20afb7b9b093a01ff8ec.png";